import { useCallback } from 'react';
import type {
  PrioritizationResult,
  InteractiveContentChoice,
} from '@core-api/presentation/types/response';
import {
  usePreviewResultsIterator,
  getHundredPointsPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

interface UseHundredPointsPreviewResultsProps {
  isEnabled: boolean;
  choices: InteractiveContentChoice[];
}

export const useHundredPointsPreviewResults = ({
  isEnabled,
  choices,
}: UseHundredPointsPreviewResultsProps): PrioritizationResult[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: PrioritizationResult[] = []) => {
      return getHundredPointsPreviewResultsIteration({
        iteration,
        previous,
        extras: { choices },
      });
    },
    [choices],
  );

  return usePreviewResultsIterator(isEnabled, getNextResults) ?? [];
};
